import { SCREEN_NAME } from 'constants/index';
import { sendUIEvent } from 'services/analytics';

// https://data-portal.internal.atlassian.com/analytics/registry/71739
const trackLearnMoreAboutKudosClick = () => {
  sendUIEvent({
    action: 'clicked',
    actionSubject: 'link',
    source: SCREEN_NAME.PROFILE,
    actionSubjectId: 'learnMoreAboutKudos',
    isPersonalView: true,
  });
};

// https://data-portal.internal.atlassian.com/analytics/registry/85850
const sendRecognitionModalOpenClickEvent = ({
  senderAaid,
  receiverAaid,
  profileInternalId,
}: {
  senderAaid?: string;
  receiverAaid?: string;
  profileInternalId?: string;
}) => {
  sendUIEvent({
    action: 'clicked',
    actionSubject: 'button',
    source: SCREEN_NAME.PROFILE,
    actionSubjectId: 'openRecognitionModal',
    isPersonalView: false,
    attributes: {
      senderAaid: senderAaid ?? '',
      receiverAaid: receiverAaid ?? '',
      profileInternalId: profileInternalId ?? '',
    },
  });
};

// https://data-portal.internal.atlassian.com/analytics/registry/85851
const sendRecognitionButtonClickEvent = ({
  recognitionReason,
  senderAaid,
  receiverAaid,
  profileInternalId,
}: {
  recognitionReason?: string;
  senderAaid?: string;
  receiverAaid?: string;
  profileInternalId?: string;
}) => {
  sendUIEvent({
    action: 'clicked',
    actionSubject: 'button',
    source: SCREEN_NAME.PROFILE,
    actionSubjectId: 'giveRecognitionButton',
    isPersonalView: false,
    attributes: {
      recognitionReason: recognitionReason ?? '',
      senderAaid: senderAaid ?? '',
      receiverAaid: receiverAaid ?? '',
      profileInternalId: profileInternalId ?? '',
    },
  });
};
export {
  trackLearnMoreAboutKudosClick,
  sendRecognitionModalOpenClickEvent,
  sendRecognitionButtonClickEvent,
};
